// extracted by mini-css-extract-plugin
module.exports =  {"size-lg":"ZXufgA1","sizeLg":"ZXufgA1","size-md":"N_r4e3N","sizeMd":"N_r4e3N","size-sm":"dt0uOV_","sizeSm":"dt0uOV_"};